$(document).ready(() => {
  const scrollSpeed = 1300
  const scrollTimeuot = 1000
  const scrollToSpeed = 800
  const width = $('.image-wrapper')[0].scrollWidth - $('.image-slider').width()
  function scrollRightLeft () {
    const scrollSpeed_calc = $('.image-wrapper')[0].scrollWidth / $('.image-slider').width() * scrollSpeed
    $('.image-wrapper').animate( { scrollLeft: width }, scrollSpeed_calc, () => {
      setTimeout(() => {
        $('.image-wrapper').animate( { scrollLeft: -width }, scrollSpeed_calc, () => {
          setTimeout(() => {
            scrollRightLeft()
          }, scrollTimeuot)
        });
      }, scrollTimeuot)
    });
  }
  scrollRightLeft()

  new Swiper('.swiper:not(.swiper-product,.swiper-preview)', {
    direction: 'horizontal',
    loop: true,
  
    hashNavigation: {
      watchState: true,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  new Swiper('.swiper-preview', {
    direction: 'horizontal',
    loop: true,
  
    hashNavigation: {
      watchState: true,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
  });

  function waitForVideoJs() {
    const videoJsLoaded = !$('video-js').toArray().some((el) => !$(el).find('video').length)

    if (videoJsLoaded)
      loadHlsVideos()
    else
      setTimeout(waitForVideoJs, 1000)
  }
  waitForVideoJs()

  function loadHlsVideos() {
    $('video-js').each(function () {
      var video = $(this).find('video')[0];
      var videoSrc = $(this).data('src');
      if (videoSrc && Hls.isSupported()) {
        var hls = new Hls();
        hls.loadSource(videoSrc);
        hls.attachMedia(video);
      }
    })
    $('video[autoplay][muted][loop]').each(function () {
      var video = $(this)[0];
      var videoSrc = $(this).data('src');
      if (videoSrc && Hls.isSupported()) {
        var hls = new Hls();
        hls.loadSource(videoSrc);
        hls.attachMedia(video);
      }
    })
  }

  (function() {
    $(document).on('click', '.common-video-block-controls > div', (e) => {
      const curVideo = $(e.target).closest('.common-videojs-block').find('video').get(0);
      curVideo.paused ? curVideo.play() : curVideo.pause();
      $(e.target).closest('.common-videojs-block').toggleClass('active');
    })
  })();
  
  let calculatorPrevValue = $('select[data-calculator-selectize-landing]').find('option[selected]').val();
  let calculatorSelectize;
  $('select[data-calculator-selectize-landing]').selectize({
    delimiter: ',',
    persist: false,
    create: false,
    onInitialize: function() {
      calculatorSelectize = this;
    },
    onChange: function (value) {
      if(!value) return

      updateCalculatorContent(this);
      calculatorPrevValue = value
    },
    onDropdownOpen: function() {
      calculatorSelectize.clear()
      calculatorSelectize.$control_input.focus()
    },
    onBlur: function() {
      if(!calculatorSelectize.items.length)
        calculatorSelectize.setValue(calculatorSelectize.search(calculatorPrevValue).items[0].id)
      $('.product__calculatorDropdownWrapper').removeClass('active')
    }
  });

  function updateCalculatorContent(selectize) {
    const contentSelect = $('select[data-type="calculator-content"]').find('option:selected').val();
    const selectedIndex = $('.product__calculator .selectize-dropdown-content div').index($(`.option[data-value='${contentSelect}']`))
    $('[data-calculator-select-value]').html(`${contentSelect}&nbsp;<span>&#9660;</span>`)
    $('.product__calculatorRightLower').html(calculatorJson[`cpsl_cpy_${selectedIndex + 1}`])
    $('.product__calculatorStat span').html(calculatorJson[`cpsl_uses_${selectedIndex + 1}`])
  }

  $('.product__calculatorDropdownWrapper').click(function() {
    $(this).addClass('active')
    calculatorSelectize.open()
  })

  $(".scroll-to").on("click", function(e){
    e.preventDefault();
    const anchor = $(this).attr('href');
    $('html, body').stop().animate({
        scrollTop: $(anchor).offset().top
    }, scrollToSpeed);
  });

$('.mobile-modal').click(function () {
  $('.js-modal-open-mobile-modal').modal()
})

$('#araki-pre-order-modal .btn-subscribe').click(function () {
  const modal = $('#araki-pre-order-modal');

  const productId = modal.data('productId');
  const variantId = modal.data('variantId');

  const data = {
    a: 'KQCdPN',
    email: modal.find('[type=email]').val(),
    variant: variantId,
    product: productId,
    platform: 'shopify',
    subscribe_for_newsletter: modal.find('#subscribe-newsletter').is(":checked")
  };

  const formBody = [];
  Object.keys(data).forEach(function (property) {
    const encodedKey = encodeURIComponent(property);
    const encodedValue = encodeURIComponent(data[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  })

  fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: formBody.join("&")
  }).then(function () {
    modal.find('.js-modal-close').click();
  })
})

  themeModals = (function() {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        bodyOpenClass: 'modal-open',
        closeOffContentClick: true
      };

      this.id = id;
      this.$modal = $('#' + id);

      if (!this.$modal.length) {
        return false;
      }

      this.nodes = {
        $parent: $('html').add('body'),
        $modalContent: this.$modal.find('.modal__inner')
      };

      this.config = $.extend(defaults, options);
      this.modalIsOpen = false;
      this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;

      this.init();
    }

    Modal.prototype.init = function() {
      var $openBtn = $(this.config.open);

      // Add aria controls
      $openBtn.attr('aria-expanded', 'false');

      $(this.config.open).on('click', this.open.bind(this));
      this.$modal.find(this.config.close).on('click', this.close.bind(this));

      // Close modal if a drawer is opened
      $('body').on('drawerOpen', function() {
        this.close();
      }.bind(this));
    };

    Modal.prototype.open = function(evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;
      if (this.$modal.attr('id') === 'SearchModal') {
        this.$modal.css('top', $('header').height());
        const height = `calc(100% - ${$('header').height()}px)`
        this.$modal.css('height', height);
      }

      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }

      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }

      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.$activeSource = $(evt.currentTarget);
      }

      if (this.modalIsOpen && !externalCall) {
        this.close();
      }

      this.$modal.addClass(this.config.openClass);
      this.nodes.$parent.addClass(this.config.bodyOpenClass);

      setTimeout(function() {
        this.$modal.addClass('aos-animate');
      }.bind(this), 0);

      this.modalIsOpen = true;

      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'true');
      }

      $('body').trigger('modalOpen.' + this.id);

      this.bindEvents();
    };

    Modal.prototype.close = function() {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }

      // deselect any focused form elements
      $(document.activeElement).trigger('blur');

      this.$modal.removeClass(this.config.openClass).removeClass('aos-animate');
      this.nodes.$parent.removeClass(this.config.bodyOpenClass);

      this.modalIsOpen = false;

      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'false').focus();
      }

      $('body').trigger('modalClose.' + this.id);

      this.unbindEvents();
    };

    Modal.prototype.bindEvents = function() {
      // Pressing escape closes modal
      this.nodes.$parent.on('keyup.modal', function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));

      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.$modal.on('click.modal', this.close.bind(this));

        // Exception to above: clicking anywhere on the modal content will NOT close it
        this.nodes.$modalContent.on('click.modal', function(evt) {
          evt.stopImmediatePropagation();
        });
      }
    };

    Modal.prototype.unbindEvents = function() {
      this.nodes.$parent.off('.modal');

      if (this.config.closeOffContentClick) {
        this.$modal.off('.modal');
        this.nodes.$modalContent.off('.modal');
      }
    };

    return Modal;
  })();

  new themeModals('araki-pre-order-modal', 'araki-pre-order-modal');
  new themeModals('mobile-modal', 'mobile-modal');
})
